import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  label: string;
  id?: string;
  note?: string;
  tone?: "light" | "dark";
  className?: string;
};
export function trackCheckout() {
  window.fbq?.("track", "InitiateCheckout");
}
export function CtaButton({
  label,
  id,
  note,
  tone = "light",
  className = ""
}: CtaButtonProps) {
  return <div className={`mx-auto w-full max-w-xl text-center ${className}`} data-id="element-27" data-mp="qjijlqm5ay1i">
      <a id={id} href={CHECKOUT_URL} onClick={trackCheckout} className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-gold-400 px-5 py-5 text-center font-extrabold uppercase tracking-wide text-navy-950 shadow-[0_10px_30px_-8px_rgba(201,162,74,0.7)] ring-1 ring-inset ring-gold-300 transition-[transform,background-color] duration-150 ease-out hover:bg-gold-300 active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-navy-700 text-[17px] leading-snug sm:text-lg" data-id="element-28" data-mp="llqvl7omfw2l">
        <span data-id="element-29" data-mp="35yqrl5lvkb0v">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-30" data-mp="35zinyinaqcs7" />
      </a>
      {note && <p className={`mt-3 text-sm ${tone === "dark" ? "text-navy-100/80" : "text-muted"}`} data-id="element-31" data-mp="3ew9igqm79jko">{note}</p>}
    </div>;
}